import { BudgetSectionGridData, PaymentGridData } from "../../helpers/grid-helpers"
import { makePrettyNumber } from "../../services/pipes/prettyNumbers.pipe"
import { BudgetSchedule, BudgetSection } from "./budget.data"

// KEEP THIS FILE OUT OF FUNCTIONS!  Had to extract it because of circular dependency, can't put it in data because of grid helpers connectino to table helpers

export const scheduleToScheduleGridData = (schedule: BudgetSchedule, total: number): PaymentGridData[] => schedule.items.map(item => {
  const { id, date, amount, description, status } = item
  return {
    id,
    payment: item,
    description: { text: description },
    date: { date: new Date(date) },
    amount: { amount },
    percent: !total ? null : { amount: amount / total * 100, showPercent: true },
    status: { status }
  }
})

export const getGridDataFromSection = (section: BudgetSection, budgetCurrency): BudgetSectionGridData[] => {
  const { settings, lineItems, id } = section
  const { useUnitRate, useMarkup, markupRate } = settings 

  // console.log({ section, budgetCurrency })

  const gridData: BudgetSectionGridData[] = lineItems.map(li => {
    const multiplier = settings.currency && settings.currency !== budgetCurrency ? (settings.conversionRate || 1 ) : 1
    const baseBudgetAmount = (li.unitCost || 0) * multiplier
    const amount = useMarkup && li.markup ? baseBudgetAmount * (1 + (markupRate || 0))
      : li.unitRate ? li.unitRate
      : li.itemId ? li.itemRate 
      : 0
    const locked = useUnitRate && useMarkup && li.markup
    return {
      id: li.id,
      lineItem: li,
      item: { text: li.item, isItem: !!li.itemId },
      description: { text: li.description },
      qty: { amount: li.quantity },
      rate: { amount: baseBudgetAmount },
      convertedRate: settings.currency && settings.currency !== budgetCurrency ? { amount: li.unitCost } : null,
      linkedUnitRate: { amount, locked },
      recurrence: { amount: li.recurrence },
      total: { amount: li.total },
      status: { dropdownOption: { id: li.status, title: li.status } },
      tax: { toggled: li.tax },
      discount: { toggled: li.discount },
      fees: { toggled: li.fees },
      show: { toggled: li.show},
      markup: { toggled: li.markup },
    }
  })
  return gridData
}
